<template>
	<div class="QuestionTypeList">
		<el-collapse v-model="collapseVisible">
			<el-collapse-item v-for="(item, index) in typeObj" :key="index" :title="item.questionsTypeName" :name="index">
				<ul class="nav-left">
					<li 
						@click="commonTopic(info)" 
						v-for="(info, k) in item.questionTypeList" 
						:key="k"
					>
						<div v-if="info.icon" style="margin: 0px auto">
							<i 
								class="zxwj-iconfont" 
								style="text-align: center;" 
								:class="info.icon" 
							></i>
							{{ info.label }}
						</div>

						<div v-else style="margin: 0px auto">
							<i 
								class="zxwj-iconfont" 
								:class="info.iconUrlSelection" 
							></i>
							{{ info.label }}
						</div>
						<el-tooltip :content="info.questionsTypeName" placement="right" effect="light">
							<span class="type-title">{{ info.questionsTypeName }}</span>
						</el-tooltip>
					</li>
				</ul>
			</el-collapse-item>
		</el-collapse>
		<div v-if="type" class="batch-add-box"><p class="btn" @click="batchAddVisible = true">{{$t('main.BatchAddQuestionTypes')}}</p></div>
		<el-dialog class="batch-add-dialog" :title="$t('main.ImportQuestion')" :visible.sync="batchAddVisible" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
			<div style="height: 600px;">
				<ImportQuestion key="importQuestion" ref="importQuestion" v-if="type == 'wj' && batchAddVisible" :path="'/questionTypeList'"></ImportQuestion>
				<ExamImportQuestion key="examImportQuestion" ref="examImportQuestion" v-if="type == 'ks' && batchAddVisible" :path="'/questionTypeList'"></ExamImportQuestion>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="batchAddVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="small" type="primary" @click="submit">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import ImportQuestion from '@/page/myQuestionnaire/importQuestion.vue';
import ExamImportQuestion from '@/page/myExam/examImportQuestion.vue';
export default {
	name: 'QuestionTypeList',
	components: {
		ImportQuestion,
		ExamImportQuestion
	},
	props: {
		typeObj: {
			type: Array,
			default: () => {
				return [];
			}
		},
		type: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			selectId: -1,
			collapseVisible: [],
			batchAddVisible: false
		};
	},
	created() {
		this.typeObj.forEach((info, index) => {
			this.collapseVisible.push(index);
		});
		// console.log('题型1111111111111', this.typeObj);
		// console.log('题型1111111111111', this.collapseVisible);
	},
	mounted() {},
	methods: {
		commonTopic(item) {
			if (this.type == 'ks') {
				this.selectId = item.questionsTypeId;
			} else {
				this.selectId = item.id;
			}
			this.$emit('commonTopic', item);
		},
		submit() {
			let refName = this.type == 'ks' ? this.$refs.examImportQuestion : this.$refs.importQuestion;
			if (this.type == 'wj') {
				refName.getJumpLogic();
			}
			this.$emit('batchAddQues', refName.paper.questionsList);
			this.batchAddVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped>

/deep/.content-box{
    height: 100%;
}
.QuestionTypeList {
	height: 100%;
	width: 100%;
    padding-bottom: 20px;
}
.nav-left .zxwj-iconfont {
	font-size: 20px;
	color: #6d7d92;
}
.nav-left li {
	cursor: pointer;
}

.nav-left {
	display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}
.nav-left i {
	display: block;
}
.nav-left li:nth-child(n + 4){
	margin-top: 10px;
}
.nav-left li {
	height: 70px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
    background-color: #eff6ff;
	border-radius: 5px;
	border: 1px solid #eff6ff;
	color: #6d7d92;
    font-weight: 600;
	i{
		color: #6d7d92;
	}
}
.nav-left li:hover {
	border-color: #0080ff;
	color: #0080ff;
	i{
		color: #0080ff;
	}
}
.batch-add-box {
	margin: 20px 0 30px 0;
	background-color: #eff6ff;
	color: #6d7d92;
    font-weight: 600;
	.btn {
		text-align: center;
		font-size: 14px;
		line-height: 52px;
		border-radius: 2px;
		cursor: pointer;
	}
}
.batch-add-dialog {
	/deep/.el-dialog {
		width: 1050px;
	}
	/deep/.el-dialog__body {
		padding: 0;
	}
}
.type-title{
	text-align: center;
	padding: 0 5px;
	font-size: 13px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	line-height: 1.5em;
	/* autoprefixer: off */
	-webkit-box-orient: vertical;
	word-break: break-all;
}
::v-deep.el-collapse {
	border: 0;
}
</style>
